export default function SwipeIcon({
  width = 8,
  height = 13,
  color = "#C0BFC1",
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 1.5C3 2.35 2.35 3 1.5 3C0.65 3 0 2.35 0 1.5C0 0.65 0.65 0 1.5 0C2.35 0 3 0.65 3 1.5ZM6.5 3C7.35 3 8 2.35 8 1.5C8 0.65 7.35 0 6.5 0C5.65 0 5 0.65 5 1.5C5 2.35 5.65 3 6.5 3ZM1.5 5C0.65 5 0 5.65 0 6.5C0 7.35 0.65 8 1.5 8C2.35 8 3 7.35 3 6.5C3 5.65 2.35 5 1.5 5ZM6.5 5C5.65 5 5 5.65 5 6.5C5 7.35 5.65 8 6.5 8C7.35 8 8 7.35 8 6.5C8 5.65 7.35 5 6.5 5ZM1.5 10C0.65 10 0 10.65 0 11.5C0 12.35 0.65 13 1.5 13C2.35 13 3 12.35 3 11.5C3 10.65 2.35 10 1.5 10ZM6.5 10C5.65 10 5 10.65 5 11.5C5 12.35 5.65 13 6.5 13C7.35 13 8 12.35 8 11.5C8 10.65 7.35 10 6.5 10Z"
        fill={color}
      />
    </svg>
  );
}
